import React, { useState } from 'react';
import { Layout, Button, Tabs, Collapse, Card, Carousel } from 'element-react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

import arrowIcon from "../assets/imgs/arrow-icon.svg";

import sourcingLogo from '../assets/imgs/sourcing_made_easy_logo.png';
import iconStar1 from '../assets/imgs/IconBuyersHighlightsStart.png';
import iconClick from '../assets/imgs/IconBuyersHighlights1.png';
import iconSearch from '../assets/imgs/IconBuyersHighlights2.png';
import iconStar from '../assets/imgs/IconBuyersHighlights3.png';
import iconCost from '../assets/imgs/IconBuyersHighlights4.png';
import iconCircle from '../assets/imgs/IconBuyersCircle.png';
import { FaExternalLinkAlt } from 'react-icons/fa';
import HelpAndSupportComponentBuyer from '../components/HelpAndSupportComponentBuyer';
import logo from "../assets/imgs/bainub_logo_white.png";

function BuyersTools() {
    // Define el estado para la pestaña activa usando useState
    const [activeTab, setActiveTab] = useState('1');
    const handleTabClick = (tab) => {
        setActiveTab(tab.props.name); // Actualiza el estado cuando se hace clic en una pestaña
    };
    //const [menuAbierto, setMenuAbierto] = useState(false);

    const tabContent = [
      { name: "1", title: "What is Bainub B2B?", content: "Bainub is a North American B2B digital platform where you can find suppliers and negotiate customized projects with specialized manufacturers in North America." },
      { name: "2", title: "Who Can Benefit from Bainub?", content: "Bainub is designed for a wide range of industrial players, from factories and specialized workshops to distributors, procurement agencies, and value added resellers. Whether you manufacture, supply, or source industrial products, Bainub helps you connect with manufacturing specialists and maximize your business opportunities across North America." },
      { name: "3", title: "Where are the suppliers located?", content: "Our suppliers are established in Mexico, ready to build nearshore partnerships and strengthen alliances across the region. Bainub is a North American B2B network focused on connecting businesses and showcasing the strength of Mexico’s manufacturing ecosystem through verified supplier listings across Mexico, the USA, and Canada." },
      { name: "4", title: "Pricing for Buyers", content: "Bainub account is free for Buyers. Find suppliers, chat directly, negotiate and establish agreements all with commision-free trading operations." }
    ];

    return (
        <>
            <div className='BuyersToolsPage'>
                <Layout.Row span="24" className="buyers-nav-bar desktop-nav" justify="center" align="middle">
                    <Layout.Col className="buyers-nav-logo">
                        <img src={sourcingLogo} alt="Sourcing Made Easy" />
                    </Layout.Col>
                    
                    <Layout.Col className="buyers-nav-links">
                        <ScrollLink to="info-for-buyers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
                            Info for Buyers
                        </ScrollLink>
                        <ScrollLink to="benefits-for-buyers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
                            Benefits for Buyers
                        </ScrollLink>
                        <ScrollLink to="tools-for-buyers" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
                            Tools for Buyers
                        </ScrollLink>
                        <ScrollLink to="faqs" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
                            FAQ'S
                        </ScrollLink>
                        <Link to="/contact-us">
                            <Button className="talk-to-us-button">TALK TO US</Button>
                        </Link>
                    </Layout.Col>
                </Layout.Row>

                {/* --- 2. VERSIÓN MÓVIL (NUEVA) --- */}
                <div className="buyers-nav-bar-mobile">
                    <div className="mobile-logo-bar">
                        <img src={sourcingLogo} alt="Sourcing Made Easy" />
                    </div>
                    <div className="mobile-links-scroll">
                        <ScrollLink to="info-for-buyers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
                            Info for Buyers
                        </ScrollLink>
                        <ScrollLink to="benefits-for-buyers" spy={true} smooth={true} offset={-80} duration={500} className="nav-link">
                            Benefits
                        </ScrollLink>
                        <ScrollLink to="tools-for-buyers" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
                            Tools
                        </ScrollLink>
                        <ScrollLink to="faqs" spy={true} smooth={true} offset={-80} duration={800} className="nav-link">
                            FAQ
                        </ScrollLink>
                        {/*<Link to="/contact-us">
                            <Button className="talk-to-us-button">TALK TO US</Button>
                        </Link>*/}
                    </div>
                </div>

                {/* --- SECCIÓN: INFORMATION FOR BUYERS (con div contenedor) --- */}
                <div id="info-for-buyers">
                    <Layout.Row className="info-for-buyers-section">
                        <Layout.Col span="24" className="section-header">
                            <div className="section-title-badge">INFORMATION FOR BUYERS</div>
                            <h2 className="section-subtitle">Connect with our network of Verified Suppliers in just a few clicks.</h2>
                        </Layout.Col>
                        <Layout.Col span="24" className="steps-process-container">
                        <Layout.Row gutter="20" justify="center">
                            
                            {/* --- PASO 1 --- */}
                            <Layout.Col xs="24" sm="24" md="4" className="step-item">
                                {/* Columna Izquierda */}
                                <div className="step-left-col"> 
                                    <div className="step-label">Step 1</div>
                                </div>
                                {/* Columna Derecha */}
                                <div className="step-right-col">
                                    <h3 className="step-item-title">JOIN BAINUB</h3>
                                    <p className="step-item-description">Create your free Buyer account.No fees, no transaction commissions.</p>
                                </div>
                            </Layout.Col>

                            {/* --- PASO 2 --- */}
                            <Layout.Col xs="24" sm="24" md="4" className="step-item">
                                <div className="step-left-col"> 
                                    <div className="step-label">Step 2</div>
                                </div>
                                <div className="step-right-col">
                                    <h3 className="step-item-title">SEARCH SMART</h3>
                                    <p className="step-item-description">Search expert manufacturers in North America and filter based on your specific needs.</p>
                                </div>
                            </Layout.Col>

                            {/* --- PASO 3 --- */}
                            <Layout.Col xs="24" sm="24" md="4" className="step-item">
                                <div className="step-left-col">
                                    <div className="step-label">Step 3</div>
                                </div>
                                <div className="step-right-col">
                                    <h3 className="step-item-title">CONNECT</h3>
                                    <p className="step-item-description">Instantly chat with manufacturing businesses. Get faster answers 24/7.</p>
                                </div>
                            </Layout.Col>

                            {/* --- PASO 4 --- */}
                            <Layout.Col xs="24" sm="24" md="4" className="step-item">
                                <div className="step-left-col"> 
                                    <div className="step-label">Step 4</div>
                                </div>
                                <div className="step-right-col">
                                    <h3 className="step-item-title">NEGOTIATE</h3>
                                    <p className="step-item-description">Share requirements, solve doubts, establish agreements in a secure environment.</p>
                                </div>
                            </Layout.Col>

                            {/* --- PASO 5 --- */}
                            <Layout.Col xs="24" sm="24" md="4" className="step-item">
                                <div className="step-left-col"> 
                                    <div className="step-label">Step 5</div>
                                </div>
                                <div className="step-right-col">
                                    <h3 className="step-item-title">TRACK AND MANAGE</h3>
                                    <p className="step-item-description">Follow up your project status and keep record in one place.</p>
                                </div>
                            </Layout.Col>

                        </Layout.Row>
                    </Layout.Col>
                    </Layout.Row>
                </div>

                {/* --- SECCIÓN: PESTAÑAS (con div contenedor) --- */}
                <div id="benefits-for-buyers">
                    <Layout.Row className="help-business-section tabs-info-section">
                        <Layout.Col span="24">
                            <h2 className="section-title">We're here to help your business grow.</h2>
                        </Layout.Col>
                        
                        {/* --- VERSIÓN DESKTOP (TABS) --- */}
                        <Layout.Col span="24" className="tabs-container-wrapper desktop-tabs">
                            <Tabs activeName={activeTab} onTabClick={handleTabClick} type="card" className="bainub-info-tabs">
                              
                              {tabContent.map(tab => (
                                <Tabs.Pane label={tab.title} name={tab.name} key={tab.name}>
                                  <div className="tab-content">
                                    <p>{tab.content}</p>
                                  </div>
                                </Tabs.Pane>
                              ))}

                            </Tabs>
                        </Layout.Col>

                        {/* --- VERSIÓN MÓVIL (CARRUSEL) --- */}
                        <Layout.Col span="24" className="mobile-carousel">
                          <Carousel autoplay={false} indicator-position="outside">
                            
                            {tabContent.map(tab => (
                              <Carousel.Item key={tab.name}>
                                <div className="carousel-content-item">
                                  <h3>{tab.title}</h3>
                                  <p>{tab.content}</p>
                                </div>
                              </Carousel.Item>
                            ))}

                          </Carousel>
                        </Layout.Col>
                    </Layout.Row>
                </div>

                {/* SECCIÓN HIGHLIGHTS */}
                <Layout.Row className="highlights-section">
                    <Layout.Col span="24">
                        <h2 className="section-title">
                            HIGHLIGHTS
                            <img src={iconStar1} alt="Star Icon" className="title-star-icon" />
                        </h2>
                    </Layout.Col>
                    <Layout.Col span="24">
                        <Layout.Row gutter="20" justify="center">
                            <Layout.Col xs="24" sm="12" md="6">
                                <div className="highlight-card">
                                    <div className="icon-container"><img src={iconClick} alt="Open & Transparent Platform" /></div>
                                    <h3 className="highlight-card-title">Open & Transparent Platform</h3>
                                    <p className="highlight-card-description">Bainub allows you to freely explore our platform. No hidden data, no payment required. View supplier profiles, capabilities, and products at no cost.</p>
                                </div>
                            </Layout.Col>
                            <Layout.Col xs="24" sm="12" md="6">
                                <div className="highlight-card">
                                    <div className="icon-container"><img src={iconSearch} alt="Diverse Sourcing Options" /></div>
                                    <h3 className="highlight-card-title">Diverse Sourcing Options</h3>
                                    <p className="highlight-card-description">Any Industry. End products, raw materials, white label products, intermediate components, customized items and more. Smart filtering tools.</p>
                                </div>
                            </Layout.Col>
                            <Layout.Col xs="24" sm="12" md="6">
                                <div className="highlight-card">
                                    <div className="icon-container"><img src={iconStar} alt="Nearshoring-Ready" /></div>
                                    <h3 className="highlight-card-title">Nearshoring-Ready</h3>
                                    <p className="highlight-card-description">Work with manufacturers based in Mexico, the U.S., or Canada to reduce lead times and simplify logistics.</p>
                                </div>
                            </Layout.Col>
                            <Layout.Col xs="24" sm="12" md="6">
                                <div className="highlight-card">
                                    <div className="icon-container"><img src={iconCost} alt="Cost for buyers" /></div>
                                    <h3 className="highlight-card-title">Cost for buyers</h3>
                                    <p className="highlight-card-description">Free account + Commision-free operations. In summary: its free!</p>
                                </div>
                            </Layout.Col>
                        </Layout.Row>
                    </Layout.Col>
                </Layout.Row>
                
                {/* --- SECCIÓN: TOOLS FOR BUYERS (con div contenedor) --- */}
                <div id="tools-for-buyers">
                    <Layout.Row className="bainub-tools-section">
                        <Layout.Col xs="24" md="12" className="tools-description-col">
                            <div className="section-title-badge">BAINUB TOOLS FOR BUYERS</div>
                            <ul className="tools-list">
                                <li>
                                    <img src={iconCircle} alt="icon" className="list-icon" />
                                    <div>
                                        <h4>Product Search Engine</h4>
                                        <p>Use our search engine to easily find manufacturers in Mexico with the expertise you require.</p>
                                    </div>
                                </li>
                                <li>
                                    <img src={iconCircle} alt="icon" className="list-icon" />
                                    <div>
                                        <h4>Instant communication with Manufacturers</h4>
                                        <p>Chat directly with Manufacturers in real time. Establish connection to solve doubts, negotiate term and establish agreements.</p>
                                    </div>
                                </li>
                                <li>
                                    <img src={iconCircle} alt="icon" className="list-icon" />
                                    <div>
                                        <h4>Create and share RFQ's</h4>
                                        <p>Reduce costs with factory direct sourcing, quote with multiple suppliers easily.</p>
                                    </div>
                                </li>
                                <li>
                                    <img src={iconCircle} alt="icon" className="list-icon" />
                                    <div>
                                        <h4>Track your project with Bainub</h4>
                                        <p>Chat directly with Manufacturers in real time. Establish connection to solve doubts, negotiate term and establish agreements.</p>
                                    </div>
                                </li>
                            </ul>
                            <Link to="/login">
                                <Button type="primary" className="get-started-button">
                                    Get Started for Free <img src={arrowIcon} alt="" className='btnIconTools'/>
                                </Button>
                            </Link>
                        </Layout.Col>
                        <Layout.Col xs="24" md="12" className="video-col">
                            <div className="responsive-iframe-container">
                                <iframe
                                    src={'https://www.youtube.com/embed/nZYHpFxR4EQ?si=QM8t-j_gKMLXVjGC'} // La URL de tu video
                                    title="Bainub Tools for Buyers"
                                    frameBorder="0"
                                    allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </Layout.Col>
                    </Layout.Row>
                </div>

                {/* --- SECCIÓN: FAQ (con div contenedor) --- */}
                <div id="faqs">
                    <Layout.Row className="faq-section">
                        <Layout.Col span="24">
                            <h2 className="section-title">BUYERS FAQ'S</h2>
                            <div className='faq-section-container'>
                                <Card bodyStyle={{ padding: "0px" }} className='faqsCard'>
                                    <HelpAndSupportComponentBuyer menu={false} />
                                </Card>
                            </div>
                        </Layout.Col>
                    </Layout.Row>
                </div>

                <div>
                    <div className='TalkContainer'>
                        <div className='TalktoUs'>
                            <Layout.Row>
                                <Layout.Col sm="24" md="16" lg="16">
                                    <h2>Talk to us</h2>
                                    <p>if you have any questions about the team, culture or values, we’re an open book, just contact us!</p>
                                </Layout.Col>
                                <Layout.Col sm="24" md="8" lg="8">
                                    <div className='responsiveSpacer'></div>
                                    <Link to="/contact-us">
                                        <div className='button'>
                                            More Information
                                        </div>
                                    </Link>
                                </Layout.Col>
                            </Layout.Row>
                        </div>
                    </div>
                    <Layout.Row className='section03'>
                        <Layout.Col xs="24" sm="24" md="18" lg="18" offset="3">
                            <h3>Ready to grow? Sign Up Now!</h3>
                            <img src={logo} alt="Bainub Logo" />
                        </Layout.Col>
                    </Layout.Row>
                </div>
            </div>
        </>
    )
}

export default BuyersTools;